import jwt_decode from 'jwt-decode';
import React, { useState, useContext, createContext } from "react";
import { getToken } from '../services/Auth';

const AuthContext = createContext({});

function AuthInfo({children}){
    const token = getToken()
    const decoded = jwt_decode(token);
    const [user] = useState(decoded.usuario_nome);
    const [user_id] = useState(decoded.usuario_id)
    const [provider] = useState(
      decoded.providers[0].nome_fantasia ? decoded.providers[0].nome_fantasia : decoded.providers[0].nome);
    const [provider_id] = useState(decoded.providers[0].usuario_id);

    return (
      <AuthContext.Provider
        value={{
            user,
            user_id,
            provider,
            provider_id,
        }}
      >
        {children}
      </AuthContext.Provider>
        )
    }
    
function useAuth(){
        const context = useContext(AuthContext);
        return context;
    }
    
export {useAuth,AuthInfo}    